/* ADD FILE */
/* UNTAPPED - FABRICS PRICE PER METRE */

/**
 * In the header is a cart icon with a count.  This count is wrong in that it includes the raw quantities.  In order to work out 
 * the actual count we want to display we need the whole cart.  The cart:count:update event only includes the line item being changed.
 * We therefore fetch and cache the whole cart, updating the after any event that may notify it has changed.  We also need to emit
 * such an event on page load to cause the initial count ot be clauclated the same way.
 * 
 * Because the details of the cart are fetched asynchronouly the count has to be hidden until the correct value is determined.
 * Otherwise it flashes a value based on real quanitties first. 
 */

/* This file is loaded as a module, so globals are module-scoped */
let cartCache = null;
let cartFetchInFlight = null;

/* The count is initially hidden by css to avoid displaying the wrong number before the cart is fetched */
/* Add a class to it. make it visible */
function revealCartCount() {
  document.querySelectorAll('hdt-cart-count').forEach(el => {
    el.classList.add('cart-count--ready');
  });
}

document.addEventListener('cart:count:update', (e) => {
  if (!e.detail) return;

  // Prevent double-adjustment
  if (e.detail.__fabricAdjusted) return;

  // If cache not ready yet, trigger fetch and bail
  if (!cartCache) {
    refreshCartCache();
    return;
  }

  e.detail.item_count = computeFabricCountFromCart(cartCache);
  e.detail.__fabricAdjusted = true;
});


async function refreshCartCache() {
  if (cartFetchInFlight) return cartFetchInFlight;

  cartFetchInFlight = fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      cartCache = cart;
      cartFetchInFlight = null;
      return cart;
    });

  return cartFetchInFlight;
}

['cart:update', 'cart:reload'].forEach(evt => {
  document.addEventListener(evt, () => {
    refreshCartCache();
  });
});

function emitCartCountUpdate() {
  if (!cartCache) return;

  const evt = new CustomEvent('cart:count:update', {
    detail: {
      item_count: computeFabricCountFromCart(cartCache),
      __fabricAdjusted: true
    }
  });

  document.dispatchEvent(evt);
}

document.addEventListener('DOMContentLoaded', async () => {
  await refreshCartCache();
  emitCartCountUpdate();
  revealCartCount();
});


function computeFabricCountFromCart(cart) {
  if (!cart?.items) return 0;

  return cart.items.reduce((sum, item) => {
    const unit = item.properties?._unit;

    // Metre-based items count as 1 per line item
    if (unit === 'metre') {
      return sum + 1;
    }

    // Ordinary items count by normal quantity
    return sum + item.quantity;
  }, 0);
}

document.addEventListener('cart:update', async () => {
  await refreshCartCache();
  emitCartCountUpdate();
});
